<template>
  <section class="app-arproc">
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12 sm12 xs12>
          <v-card outlined class="app-card">
            <v-card-title class="app-card-title">
              NJI DAEs
            </v-card-title>

            <v-card-text class="app-card-content">
              <v-alert outlined type="info" text>
                Abaixo é possível pesquisar o DAE.
                Basta digitar o número do auto de infração na pesquisa.
              </v-alert>

              <br />

              <v-form
                ref="form"
                lazy-validation
                v-model="formModel.valid"
                @submit.prevent="onSubmit"
              >
                <v-row>
                  <v-col :md="12" :sm="12" :xs="12" cols="12">
                    <v-text-field
                      type="text"
                      label="Número do Auto de Infração"
                      placeholder="Ex.: 000001"
                      v-model="formModel.infracao"
                      :rules="[
                        rules.required,
                        rules.min,
                        rules.max,
                        rules.number
                      ]"
                      filled
                      rounded
                      dense
                      ref="infracao"
                      append-icon="search"
                    ></v-text-field>
                  </v-col>

                  <v-col :md="9" :sm="9" :xs="12" cols="12">
                    <vue-recaptcha
                      ref="recaptcha"
                      :sitekey="siteKey"
                      :loadRecaptchaScript="true"
                      @verify="verifyRecaptcha"
                      @expired="expiredRecaptcha"
                      class="recaptcha"
                    ></vue-recaptcha>
                    <v-input
                      v-model="formModel.recaptcha"
                      :rules="[rules.required]"
                    ></v-input>
                  </v-col>

                  <v-col :md="3" :sm="3" :xs="12" cols="12">
                    <v-btn
                      depressed
                      block
                      large
                      color="primary"
                      type="submit"
                    >Continuar</v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>

          <div class="text-xs-center area-loading" v-if="isLoading">
            <v-progress-circular
              indeterminate
              color="primary"
              :size="20"
              :width="2"
            ></v-progress-circular>
            <span class="text-loading">Buscando ...</span>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import Vue from "vue"
import VueRecaptcha from "vue-recaptcha";
import GlobalStore from "@/store/modules/global";
import MinioService from "@/services/minio.service";
import { VUE_APP_RECAPTCHA_KEY } from "@/commons/config";
import { delay } from "rxjs/operators";

export default Vue.extend({
  components: { VueRecaptcha },
  metaInfo: {
    title: "NJI DAE - Central de Serviços"
  },
  data: () => ({
    siteKey: VUE_APP_RECAPTCHA_KEY,
    isLoading: false,
    formModel: {
      infracao: null,
      recaptcha: null
    },
    valid: false,
    rules: {
      required: value => !!value || "Esse campo deve ser preenchido",
      number: value => {
        let num = parseInt(value);
        return (!!num && value == num) || "Campo númerico de 3 à 8 caracteres"
      },
      max: value => (!!value && value.length < 9) || "Esse campo deve possuir até 8 caracteres",
      min: value => (!!value && value.length >= 3) || "Esse campo deve possuir pelo menos 3 caracteres"
    }
  }),
  methods: {
    verifyRecaptcha(value) {
      this.formModel.recaptcha = value;
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.formModel.recaptcha = null;
    },
    initData() {
      const { query } = this.$route;
      if (query && query.numero) {
        this.formModel.infracao = query.numero;
        this.onSubmit();
      }
    },
    onSubmit() {
      this.valid = this.$refs.form.validate();
      if (this.valid) {
        this.isLoading = true;
        const { infracao, recaptcha } = this.formModel;
        MinioService
          .downloadNjiDae(infracao, recaptcha)
          .pipe(delay(1000))
          .subscribe(document => {
            this.download(document)
            this.isLoading = false
          },
          error => {
            const message = "Alguns erros foram encontrados. Favor verifique o número do auto de infração";
              GlobalStore.setSnackBar({ message, show: true, type: "error", timeout: 30000 });
              this.isLoading = false;
          })
      }
    },
    download(document) {
      const blob = new Blob([document], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      window.open(url);
    }
  },
  mounted() {
    this.initData();
  }
})
</script>
